import { __decorate } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ApiService, ConfigOauthService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

const SPE_J_CASHOUT = '/spe-j-cash-out';
let SpeJCashoutCelCoin = class SpeJCashoutCelCoin {
    constructor(api) {
        this.api = api;
    }
    rechargeMobile(data, uuidAccountPayment, transactionId) {
        const uri = `${SPE_J_CASHOUT}/api/celcoin/transaction/topups`;
        return this.api.post(uri, data, uuidAccountPayment);
    }
};
SpeJCashoutCelCoin.ctorParameters = () => [
    { type: ApiService }
];
SpeJCashoutCelCoin = __decorate([
    Injectable()
], SpeJCashoutCelCoin);

const SPE_J_CASHOUT$1 = '/px-celcoin';
let celCoinSteps = class celCoinSteps {
    constructor(api) {
        this.api = api;
    }
    consultProviders(stateCode, type, category) {
        const uri = `${SPE_J_CASHOUT$1}/v1/providers?stateCode=${stateCode}&type=${type}&category=${category}`;
        return this.api.get(uri);
    }
    providerValues(stateCode, providerId) {
        const uri = `${SPE_J_CASHOUT$1}/v1/provider-values?stateCode=${stateCode}&providerId=${providerId}`;
        return this.api.get(uri);
    }
    findProvider(stateCode, phoneNumber) {
        const uri = `${SPE_J_CASHOUT$1}/v1/find-providers?stateCode=${stateCode}&PhoneNumber=${phoneNumber}`;
        return this.api.get(uri);
    }
};
celCoinSteps.ctorParameters = () => [
    { type: ApiService }
];
celCoinSteps = __decorate([
    Injectable()
], celCoinSteps);

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

let UiPxCelCoinModule = class UiPxCelCoinModule {
};
UiPxCelCoinModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            ConfigService, SpeJCashoutCelCoin, celCoinSteps
        ]
    })
], UiPxCelCoinModule);

/*
 * Public API Surface of ui-px-token
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConfigService, SpeJCashoutCelCoin, UiPxCelCoinModule, celCoinSteps };
//# sourceMappingURL=wlp-ui-px-celcoin.js.map
